import axios from 'axios';

export default class LoginService {

  login(username, password) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/account/api/v1/login",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Basic R1JUcG9lNDVFMjFLZToyNzE4ZWE4YTBhMzg0YzkyYjc3YjkyZWRiNTRhZjU0Yg=="
      },
      data: {
        username: username,
        password: password
      }
    })
    .then(res => res)
    .catch(error => error.response);
  }

  send_forgot_password_link(username, email) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/account/api/v1/forgot",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Basic R1JUcG9lNDVFMjFLZToyNzE4ZWE4YTBhMzg0YzkyYjc3YjkyZWRiNTRhZjU0Yg=="
      },
      data: {
        username: username,
        email: email
      }
    })
    .then(res => res)
    .catch(error => error.response);
  }

  reset_password(password, confirm_password, token) {
    return axios({
      method: 'post',
      url: process.env.VUE_APP_BASE_URL + "/account/api/v1/reset",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Basic R1JUcG9lNDVFMjFLZToyNzE4ZWE4YTBhMzg0YzkyYjc3YjkyZWRiNTRhZjU0Yg=="
      },
      data: {
        password: password,
        confirm_password: confirm_password,
        token: token
      }
    })
    .then(res => res)
    .catch(error => error.response);
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user_info");
    window.location.href = '/login';
  }

}
